/**
 * Created by tomnotcat on 2021/11/22.
 */
import React from "react";
import _ from "lodash";
import { withTranslation } from "react-i18next";
import { Image, StyleSheet, Text, TouchableOpacity, View } from "react-native";
import SketchCanvasModal from "./SketchCanvasModal";
import Icon from "react-native-vector-icons/Ionicons";
import * as Helper from "../../utils/Helper";
import UIDs from "../../UIDs";

const uid = UIDs.components.ui.writeInput;

class WriteInput extends React.Component {
    constructor(props) {
        super(props);

        let imagesValue = [];
        if(this.props.value){
            let newValue = this.props.value.replace("@files@","");
            let newImg = newValue.split("|");

            newImg.map((item) => {
                const newItem = {
                    base64: "",
                    virtualPath: item,
                };
                imagesValue.push(newItem);
            });
        }
        this.state = {
            height: 40,
            images: imagesValue,
        }
    }

    componentDidMount() {
    }

    componentWillUnmount() {
        this._unmounted = true;
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.value !== this.props.value) {
            if (this._getResult() !== this.props.value) {
                // TODO: update this.state.images from props.value
            }
        }
    }

    _setupSketch = (r) => {
        this._sketch = r;
    };

    _updateLayout = ({nativeEvent}) => {
        var lineCount = parseInt(Math.ceil(nativeEvent.layout.height / 40));
        if (lineCount < 1) {
            lineCount = 1;
        }

        var height = 40 * lineCount;
        if (height !== this.state.height) {
            this.setState({height});
        }
    };

    _getResult() {
        /* result format:
           @files@~/fs/temp/tables/123.png|~/fs/temp/tables/456.png
        */
        var result = [];
        this.state.images.map((item) => {
            if (item.virtualPath) {
                result.push(item.virtualPath);
            }
        });

        if (result.length > 0) {
            return '@files@' + result.join('|');
        }
        return "";
    }

    _updateChange = () => {
        if (this.props.onChangeText) {
            this.props.onChangeText(this._getResult());
        }
    };

    _onSave = (result) => {
        var newImages = _.clone(this.state.images);
        var newItem = newImages.find(a => a.id === result.editId);
        if (newItem) {
            newItem.base64 = result.encoded;
            newItem.virtualPath = '';
        }
        else {
            newItem = {
                id: '' + Date.now(),
                base64: result.encoded,
                virtualPath: '',
            };
            newImages.push(newItem);
        }
        this.setState({images: newImages});

        if (this.props.onSaveImage) {
            this.props.onSaveImage(newItem.id, result.encoded, (r) => {
                if (this._unmounted) {
                    return;
                }

                var newImages = _.clone(this.state.images);
                var it = newImages.find(a => a.id === newItem.id);
                if (it) {
                    if (r.virtualPath) {
                        it.virtualPath = r.virtualPath;
                    }
                    else {
                        // 保存图片失败, 删除对应项
                        newImages.splice(newImages.indexOf(it), 1);
                    }

                    this.setState({images: newImages}, () => {
                        this._updateChange();
                    });
                }
            });
        }
        else {
            console.warn('no onSaveImage!!!');
        }
    };

    _onEdit = (id) => {
        if (this._sketch) {
            this._sketch._open(id);
        }
    };

    _onDelete = (id) => {
        var newImages = _.clone(this.state.images);
        var index = newImages.findIndex(a => a.id === id);
        if (index >= 0) {
            newImages.splice(index, 1);
            this.setState({images: newImages}, () => {
                this._updateChange();
            });
        }
    };

    renderImage(item, index) {
        var url = item.base64 ? `data:image/png;base64,${item.base64}` : Helper.buildFilePathInUnits(item.virtualPath, this.props.useLocalFilePath);
        return (
            <TouchableOpacity style={{marginBottom: 2}} key={index} onPress={() => this._onEdit(item.id)}>
                <View>
                    {this.props.isReadonly ? null : <TouchableOpacity style={{ zIndex: 10, position: 'absolute', top: -2, right: 4 }}
                        onPress={() => {
                            this._onDelete(item.id);
                        }}
                    >
                        <View style={{alignItems: 'center', justifyContent: 'center',
                                      width: 12, height: 12, borderRadius: 5, color: '#fff' }}>
                            <Icon name="ios-remove-circle" style={{fontSize: 14, marginTop: -2, color:"#BFBFBF"}} />
                        </View>
                    </TouchableOpacity>}
                    <Image style={styles.image} source={{ uri: url }}/>
                </View>
            </TouchableOpacity>);
    }

    render() {
        const { inputStyle, ...props } = this.props;
        return (
            <View style={{flexDirection: 'column', paddingBottom: 0, height: this.state.height}} {...props}>
                <View style={{flex: 1}}/>
                <TouchableOpacity disabled={this.state.images.length > 0}
                    onPress={() => {
                        if (this._sketch) {
                            this._sketch._open();
                        }
                    }}>
                <View style={{flexDirection: 'row', flexWrap: "wrap",
                    marginLeft: 4, alignItems: 'flex-end',
                    borderBottomWidth: StyleSheet.hairlineWidth, borderColor: "#D9D5DC"}}
                    onLayout={this._updateLayout}
                    pointerEvents = "auto"
                >
                    {this.state.images.length === 0 ?
                     (<Text style={[inputStyle, styles.inputTextStyle]} >{this.props.t("defaultPlaceHolder")}</Text>) : null}
                    {this.state.images.map((item, index) => this.renderImage(item, index))}
                    <TouchableOpacity onPress={() => {
                                          if (this._sketch) {
                                              this._sketch._open();
                                          }
                                      }}>
                    <SketchCanvasModal ref={this._setupSketch}
                                       style={{width: 20, height: 20, alignItems: 'center', justifyContent: 'center',
                                               marginLeft: this.state.images.length > 0 ? 20 : 0}}
                        char={' '}
                        useAddIcon={this.state.images.length>0}
                        isReadonly = {this.props.isReadonly}
                        onSave={this._onSave}
                    />
                    </TouchableOpacity>
                </View>
                </TouchableOpacity>
                <View style={{height: this.state.images.length > 0 ? 0 : 8}}/>
            </View>);
    }
}

const styles = StyleSheet.create({
    inputTextStyle: {
        //fontSize: 14,
        color: "#ccc",
        marginRight: 10,
    },
    image: {
        width: 36,
        height: 36,
        marginRight: 10,
        backgroundColor: "#f3f9fc",
    },
});

export default withTranslation(uid, { withRef: true })(WriteInput);
